import getFullName from "../utils/getFullName";
const ENDPOINT = process.env.REACT_APP_ENDPOINT

async function getHint(type, id, usedIds) {
    const newType = type === 'MEDIA' ? 'ACTOR' : 'MEDIA'
    const baseUrl = `${ENDPOINT}/snake/hint`;
    const url = `${baseUrl}/${type}/id/${id}`;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify([...usedIds])
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        const extraData = {
            type: newType,
            hint: true,
            name: newType === 'MEDIA' ? data.title : getFullName(data)
        }
        return {...data, ...extraData};
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
}

export default getHint;